<template>
  <div class="modal" v-bind:class="{ 'is-active': is_shown }">
    <div class="modal-background" @click="close_modal"></div>
    <div class="modal-card">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ $t("generate module") }}</p>
        <button class="delete" aria-label="close" @click="close_modal"></button>
      </header>
      <section class="modal-card-body">
        <div class="columns">
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("name") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.name" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("table name") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.table_name" />
              </div>
            </div>
          </div>
          <div class="column">
            <div class="field">
              <label class="label">{{ $t("id field name") }}</label>
              <div class="control">
                <input class="input" type="text" v-model="meta.id_field_name" />
              </div>
            </div>
          </div>
        </div>

        <div class="notification is-danger mt-5" v-if="error">
          <p v-html="error"></p>
        </div>
      </section>
      <footer class="modal-card-foot">
        <p class="buttons">
          <button
            class="button is-rounded is-primary"
            :disabled="!is_form_valid"
            @click="save"
          >
            <span class="icon"><i class="fa fa-save"></i></span>
            <span>{{ $t("save") }}</span>
          </button>
          <button class="button is-rounded is-danger" @click="close_modal">
            <span class="icon"><i class="fa fa-close"></i></span>
            <span>{{ $t("close") }}</span>
          </button>
        </p>
      </footer>
    </div>
  </div>
</template>
<script>
import { generate_error_message_text, put, get } from "@/utils";
import "bulma-extensions/bulma-checkradio/dist/css/bulma-checkradio.min.css";

export default {
  name: "CreateModuleModal",
  // components: { Permissions },
  data() {
    return {
      is_shown: false,
      meta: {},
      error: "",
    };
  },
  computed: {
    is_form_valid() {
      let v = this;
      return v.meta && v.meta.name;
    },
  },
  methods: {
    set_initial_state() {
      this.meta = {};
      this.error = "";
    },
    close_modal() {
      let v = this;
      v.is_shown = false;
      v.set_initial_state();
    },
    show_modal() {
      let v = this;
      v.is_shown = true;
      v.set_initial_state();
    },
    save() {
      let v = this;
      let data = { ...v.meta };
      put("/module/generate", data)
        .then(() => {
          v.close_modal();
          v.$emit("success");
        })
        .catch((error) => {
          v.error = generate_error_message_text(error);
        });
    },
  },
  mounted() {},
  watch: {
    "meta.name": function (value) {
      let v = this;
      v.meta.table_name = `${value.toLowerCase()}_${value.toLowerCase()}`;
      v.meta.id_field_name = `${value.toLowerCase()}_id`;
    },
  },
};
</script>
<style></style>
